import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

// 重写路由的push方法
// const routerPush = Router.prototype.push
// Router.prototype.push = function push(location) { 
//   return routerPush.call(this, location).catch(error => error)
// }

// 定义路由
const createRouter = () => new Router({
  routes: [
    {
      path: '/',
      component: () => import("../views/layout/index.vue"),
      hidden: true,
      redirect: '/redirect',
      children: [{
        path: 'redirect',
        component: () => import('@/views/redirect/index.vue')
      }]
    },
    {
      path: '/login',
      name: 'login',
      component: () => import("../views/login/login.vue"),
    },
    {
      path: '/RegisterPage',
      name: 'RegisterPage',
      component: () => import("../views/merchantRegister/register.vue"),
    },
    {
      path: '*',
      component: () => import('@/views/error-page/401'),
      hidden: true
    },
  ],
  // 解决路由跳转后，不显示在首行
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});
const router = createRouter()
// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}
export default router;